export const apiGatewayClient = {
  invokeUrl: `${process.env.GATSBY_AWS_INVOKE_URL}`.toString(),
  region: `${process.env.GATSBY_AWS_REGION}`.toString(),
  accessKey: `${process.env.GATSBY_AWS_ACCESS_KEY}`.toString(),
  secretKey: `${process.env.GATSBY_AWS_SECRET_KEY}`.toString(),
};
